import { NewCustomerButton, OngoingNewBusinessModule, PageHeader } from '@korint/folio';

export function OngoingNewBusiness() {
  return (
    <div>
      <PageHeader title="Accueil" right={<NewCustomerButton />} />
      <OngoingNewBusinessModule />
    </div>
  );
}
